<template>
  <div class="content-container">
    <!-- 密码输入弹窗 -->
    <el-dialog title="请输入访问密码" :visible.sync="pswDialogVisible" width="400px" :close-on-click-modal="false">
      <el-form>
        <el-form-item label="密码">
          <el-input v-model="psw" type="password" placeholder="请输入访问密码"
            @keyup.enter.native="handlePswConfirm"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="pswDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handlePswConfirm">确认</el-button>
      </span>
    </el-dialog>

    <el-form :inline="true" :model="formInline" class="demo-form-inline" label-width="100px">
      <div>
        <el-form-item label="机器号">
          <el-input v-model="formInline.machineid" placeholder="请输入机器号"></el-input>
        </el-form-item>
        <el-form-item label="IMEI号">
          <el-input v-model="formInline.imei" placeholder="请输入IMEI号"></el-input>
        </el-form-item>
        <el-form-item label="消息时间">
          <el-date-picker v-model="formInline.createtime" type="datetimerange" range-separator="~"
            start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-tooltip class="item" effect="dark" content="最多输出300条数据" placement="bottom">
            <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          </el-tooltip>
          <el-button type="warning" icon="el-icon-check" @click="setTimeInterval(30)">最近30分</el-button>
          <el-button type="primary" icon="el-icon-caret-left" @click="setTimePrev(120)">2H</el-button>
          <el-button type="success" icon="el-icon-arrow-left" @click="setTimePrev(60)">1H</el-button>
          <el-button type="success" icon="el-icon-arrow-right" @click="setTimeNext(60)">1H</el-button>
          <el-button type="primary" icon="el-icon-caret-right" @click="setTimeNext(120)">2H</el-button>
        </el-form-item>
      </div>
    </el-form>

    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="id" label="id" width="120"></el-table-column>
      <el-table-column prop="imei" label="imei" width="200">
        <template slot-scope="scope">
          <div>{{ scope.row.imei }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="message" label="类型" width="80">
        <template slot-scope="scope">
          <el-tag type="success" effect="dark" size="mini" v-if="scope.row.type == 0">接收</el-tag>
          <el-tag type="normal" effect="dark" size="mini" v-else-if="scope.row.type == 1">发送</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="message" label="消息"></el-table-column>
      <el-table-column label="ICCID" width="120">
        <template slot-scope="scope">
          <div>{{ getICCID(scope.row.message) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="RSSI" width="200">
        <template slot-scope="scope">
          <el-progress :text-inside="true" :stroke-width="16" :percentage="getRSSI(scope.row.message)"
            :color="customColors"></el-progress>
        </template>
      </el-table-column>
      <el-table-column label="时间" width="200">
        <template slot-scope="scope">
          <div>{{ scope.row.createtime | formatDateTimeSSS }}</div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import moment from "moment";
import smCrypto from "sm-crypto";
const { encrypt } = smCrypto.sm4;

// SM4密钥转换：将普通字符串转为16进制hex串（16字节 → 32hex字符）
// function strToHex(str) {
//   return str.split('').map(c => c.charCodeAt(0).toString(16).padStart(2, '0')).join('');
// }

const SM4_KEY = "0123FAFA89ABCDEFFEDCBA9ABABAB210";

export default {
  name: "NotifyMessagePublic",
  data() {
    return {
      pswDialogVisible: false,
      psw: "",
      formInline: {
        imei: "",
        machineid: "",
        createtime: [moment().subtract(20, "minute"), moment()]
      },
      tableData: [],
      customColors: [
        { color: "#f56c6c", percentage: 50 },
        { color: "#e6a23c", percentage: 80 },
        { color: "#67c23a", percentage: 100 }
      ]
    };
  },
  mounted() {
    if (this.$route.query.machineid) {
      this.formInline.machineid = this.$route.query.machineid;
    }
    if (this.$route.query.from && this.$route.query.to) {
      this.formInline.createtime = [this.$route.query.from, this.$route.query.to];
      this.onSubmit();
    }
  },
  methods: {
    // SM4加密，输出Base64格式（与Java端兼容）
    encryptPsw(plainText) {
      if (!plainText) return "";
      try {
        const encryptedBytes = encrypt(plainText, SM4_KEY, { output: 'array' });
        return btoa(String.fromCharCode(...encryptedBytes));
      } catch (e) {
        console.error("SM4加密失败:", e);
        return "";
      }
    },

    getPsw() {
      return localStorage.getItem("psw") || "";
    },
    setPsw(val) {
      const encryptedPsw = this.encryptPsw(val);
      localStorage.setItem("psw", encryptedPsw);
    },
    showPswDialog() {
      this.psw = "";
      this.pswDialogVisible = true;
    },
    handlePswConfirm() {
      if (!this.psw) {
        this.$message.warning("请输入访问密码");
        return;
      }
      this.setPsw(this.psw);
      this.pswDialogVisible = false;
      this.doQuery();
    },
    onSubmit() {
      if (!this.getPsw()) {
        this.showPswDialog();
        return;
      }
      this.doQuery();
    },
    doQuery() {
      const encryptedPsw = this.getPsw();
      let queryModel = {
        machineid: this.formInline.machineid,
        imei: this.formInline.imei,
        createtimeFrom: Array.isArray(this.formInline.createtime)
          ? this.$ToDateTimeString(this.formInline.createtime[0])
          : null,
        createtimeTo: Array.isArray(this.formInline.createtime)
          ? this.$ToDateTimeString(this.formInline.createtime[1])
          : null
      };
      this.$axios(this.$urlMapping["上报消息查询Out"], {
        data: queryModel,
        headers: { psw: encryptedPsw }
      }).then(result => {
        console.log("result:", result);
        this.tableData = result;
      }).catch(err => {
        console.log('catch');
        console.log(err);
        this.psw = "";
        localStorage.removeItem("psw");
        this.pswDialogVisible = true;

      });
    },
    setTimeInterval(val) {
      this.formInline.createtime = [moment().subtract(val, "minute"), moment()];
    },
    setTimePrev(val) {
      let start = moment(this.formInline.createtime[0]).subtract(val, "minute");
      let end = moment(this.formInline.createtime[1]).subtract(val, "minute");
      this.formInline.createtime = [start, end];
    },
    setTimeNext(val) {
      let start = moment(this.formInline.createtime[0]).add(val, "minute");
      let end = moment(this.formInline.createtime[1]).add(val, "minute");
      this.formInline.createtime = [start, end];
    },
    getICCID(val) {
      try {
        let a = JSON.parse(val);
        if (a.report && a.report.iccid) return a.report.iccid;
        if (a.extra && a.extra.ICCID) return a.extra.ICCID;
        return "";
      } catch (e) {
        return "";
      }
    },
    getRSSI(val) {
      try {
        let a = JSON.parse(val);
        let rssi = null;
        if (a.report && a.report.rssi != null) rssi = a.report.rssi;
        else if (a.extra && a.extra.RSSI != null) rssi = a.extra.RSSI;
        if (rssi != null) return Math.trunc((rssi * 100) / 31);
        return 0;
      } catch (e) {
        return 0;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.content-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px;
}

/deep/ .el-select {
  width: 202px;
}
</style>
